import ApiClient, { ApiClientPromiseResponse } from "services/ApiClient";
import qs from "qs";

import { formatSortField } from "utils/FormatUtils";
import { DashboardInspectionFilter, DashboardInspectionFilterResponse, InspectionCalendarModel, ProjectInspectionListItem, ProjectInspectionMapItem } from "types/dashboard";
import { PagedData } from "types";

const PAGE_SIZE = 10;

class DashboardInspectionsService extends ApiClient {
  getDashboardInspections(filters: DashboardInspectionFilter & { searchFilter: string; sortBy: any; }): ApiClientPromiseResponse<PagedData<ProjectInspectionListItem>> {
    const { page = 1, pageSize = PAGE_SIZE, sortBy, searchFilter } = filters;
    const query: DashboardInspectionFilter = {
      ...filters,
      page,
      pageSize,
    };

    if (sortBy && sortBy.field && sortBy.direction !== "None") {
      query.sortFieldName = formatSortField(sortBy.field);
      query.sortDirection = sortBy.direction;
    }

    if (searchFilter) {
      query.name = searchFilter;
    }

    return this.call({
      method: "get",
      url: `/dashboard/inspections/list?${qs.stringify(query)}`,
    });
  }

  getInspectionsForCalendar(filters: DashboardInspectionFilter): ApiClientPromiseResponse<InspectionCalendarModel> {
    return this.call({
      method: "get",
      url: `/dashboard/inspections/calendar?${qs.stringify(filters)}`,
    });
  }

  getInspectionsForMap(filters: DashboardInspectionFilter): ApiClientPromiseResponse<ProjectInspectionMapItem[]> {
    return this.call({
      method: "get",
      url: `/dashboard/inspections/map?${qs.stringify(filters)}`,
    });
  }

  getFilters(params: DashboardInspectionFilter): ApiClientPromiseResponse<DashboardInspectionFilterResponse> {
    const queryParams = params && qs.stringify(params);

    return this.call<DashboardInspectionFilterResponse>({
      method: "get",
      url: `/dashboard/inspections/filters?${queryParams}`,
    });
  }
}

export default new DashboardInspectionsService();
